import * as vp from 'vopay';

import { FunctionComponent, useState } from 'react';
import { startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import styles from './AccountingSystemScheduleSidebar.module.scss';

import { Button } from '#shared/components/UI';

const { SubTitle, DatepickerSimple } = vp;

type AccountingSystemScheduleSidebarProps = {
  isVisible: boolean;
  defaultDate?: string;
  onSchedule: (savedValues: string) => void;
  close: () => void;
};
type FC = FunctionComponent<AccountingSystemScheduleSidebarProps>;

const AccountingSystemScheduleSidebar: FC = ({
  isVisible,
  close,
  defaultDate,
  onSchedule,
}: AccountingSystemScheduleSidebarProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.AccountingSystem.OpenTab.ScheduleSidebar' });
  const [currentDate, setCurrentDate] = useState(defaultDate || '');

  return (
    <div className={[styles.sidebar, isVisible ? styles.show : ''].join(' ')}>
      {/* I know that the fonts are different from the Figma designs, but currently
      we're undergoing a redesign, so just leaving it as-is for now. */}
      <SubTitle subTitle={t('title', { defaultValue: 'Schedule Pay Date' })} center fontSize="16px" />

      <DatepickerSimple
        name="scheduledDate"
        variant="outline"
        isInline
        value={currentDate || ''}
        onBlur={() => {}}
        min={vp.createTimestamp(startOfDay(new Date()).getTime())}
        onChange={(event) => {
          const selectedDate = event.target.value;
          setCurrentDate(selectedDate);
        }}
      />

      <div className={styles.ctaButtons}>
        {/* I know that the fonts are different from the Figma designs, but currently
      we're undergoing a redesign, so just leaving it as-is for now. */}
        <Button
          id="save-schedule-date"
          colorScheme="primary"
          onClick={() => {
            onSchedule(currentDate);
          }}
          style={{ width: '100%' }}
        >
          {t('scheduleAll', { defaultValue: 'Schedule All' })}
        </Button>

        <Button id="confirmationDialogue-close" colorScheme="secondary" style={{ width: '100%' }} onClick={close}>
          {t('cancel', { defaultValue: 'Cancel' })}
        </Button>
      </div>
    </div>
  );
};

export default AccountingSystemScheduleSidebar;
